export default __webpack_public_path__ + "static/image3-362b6114343f529013c4f1f373bed3af.svg";